<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <p class="lead">Adicionar B.V.</p>
        </div>
      </div>

      <form @submit="save"  enctype="multipart/form-data">
        <div class="p-fluid p-formgrid p-grid">

          <div class="p-field p-col-12">
            <label class="form-check-label">
              B.V. está sinalizada?
            </label>
            <div class="d-flex" style="max-width: 500px">
              <div class="form-check form-check-inline">
                <button
                  v-on:click="setButton('is_flagged', 1, $event)"
                  class="form-button form-button-yes mr-3"
                  v-bind:class="{ 'border-active': form.is_flagged }"
                >
                  <label class="form-check-label">
                    Sim
                  </label>
                </button>
              </div>
              <div class="form-check form-check-inline">
                <button
                  v-on:click="isNotFlaggedClick($event)"
                  class="form-button form-button-no mr-3"
                  v-bind:class="{ 'border-active': !form.is_flagged }"
                >
                  <label class="form-check-label">
                    Não
                  </label>
                </button>
              </div>
            </div>
          </div>

          <div class="p-field p-col-12" v-if="form.is_flagged">
            <div class="form-check form-check-inline mt-3">
              <button
                v-on:click="toggleButton('without_pictogram', $event)"
                class="buttons mr-3"
                v-bind:class="{ 'buttons-active': form.without_pictogram }"
              >
                <label class="form-check-label">
                  Sem Pictograma
                </label>
              </button>
            </div>

            <div class="form-check form-check-inline">
              <button
                v-on:click="toggleButton('is_unreadable', $event)"
                class="buttons mr-3"
                v-bind:class="{ 'buttons-active': form.is_unreadable }"
              >
                <label class="form-check-label">
                  Ilegível / Improvisada
                </label>
              </button>
            </div>

            <div class="form-check form-check-inline">
              <button
                v-on:click="toggleButton('without_number', $event)"
                class="buttons"
                v-bind:class="{ 'buttons-active': form.without_number }"
              >
                <label class="form-check-label">
                  Sem Número
                </label>
              </button>
            </div>
          </div>

          <div class="p-field p-col-12">
            <label class="form-check-label">
              E.C. Necessita Ponto de Resgate?
            </label>
            <div class="d-flex" style="max-width: 500px">
              <div class="form-check form-check-inline">
                <button
                  v-on:click="setButton('is_rescue_point_required', 1, $event)"
                  class="form-button form-button-yes mr-3"
                  v-bind:class="{ 'border-active': form.is_rescue_point_required }"
                >
                  <label class="form-check-label">
                    Sim
                  </label>
                </button>
              </div>
              <div class="form-check form-check-inline">
                <button
                  v-on:click="noRescuePointRequiredClick($event)"
                  class="form-button form-button-no mr-3"
                  v-bind:class="{ 'border-active': !form.is_rescue_point_required }"
                >
                  <label class="form-check-label">
                    Não
                  </label>
                </button>
              </div>
            </div>
          </div>

          <div class="p-field p-col-12" v-if="form.is_rescue_point_required">
            <label class="form-check-label">
              B.V. Possui Ponto de Resgate?
            </label>
            <div class="d-flex" style="max-width: 500px">
              <div class="form-check form-check-inline">
                <button
                  v-on:click="setButton('has_rescue_point', 1, $event)"
                  class="form-button form-button-yes mr-3"
                  v-bind:class="{ 'border-active': form.has_rescue_point }"
                >
                  <label class="form-check-label">
                    Sim
                  </label>
                </button>
              </div>
              <div class="form-check form-check-inline">
                <button
                  v-on:click="hasNotRescuePointClick($event)"
                  class="form-button form-button-no mr-3"
                  v-bind:class="{ 'border-active': !form.has_rescue_point }"
                >
                  <label class="form-check-label">
                    Não
                  </label>
                </button>
              </div>
            </div>
          </div>

          <div class="p-field p-col-12" v-if="form.has_rescue_point">
            <div class="form-check form-check-inline mt-3">
              <button
                v-on:click="toggleButton('is_rescue_point_flagged', $event)"
                class="buttons mr-3"
                v-bind:class="{ 'buttons-active': !form.is_rescue_point_flagged }"
              >
                <label class="form-check-label">
                  Não Sinalizado
                </label>
              </button>
            </div>

            <div class="form-check form-check-inline">
              <button
                v-on:click="toggleButton('is_rescue_point_max_load_indicated', $event)"
                class="buttons mr-3"
                v-bind:class="{ 'buttons-active': !form.is_rescue_point_max_load_indicated }"
              >
                <label class="form-check-label">
                  Sem Indicação de Carga Max.
                </label>
              </button>
            </div>

            <div class="form-check form-check-inline">
              <button
                v-on:click="toggleButton('rescue_point_has_project', $event)"
                class="buttons"
                v-bind:class="{ 'buttons-active': !form.rescue_point_has_project }"
              >
                <label class="form-check-label">
                  Sem Projeto
                </label>
              </button>
            </div>
          </div>

          <div class="p-field p-col-12">
            <label class="form-check-label">
              B.V. possui travamento?
            </label>
            <div class="d-flex" style="max-width: 600px">
              <div class="form-check form-check-inline">
                <button
                  v-on:click="setButton('lock', 1, $event)"
                  class="form-button form-button-yes mr-3"
                  v-bind:class="{ 'border-active': form.lock == 1 }"
                >
                  <label class="form-check-label">
                    Sim
                  </label>
                </button>
              </div>
              <div class="form-check form-check-inline">
                <button
                  v-on:click="setButton('lock', 0, $event)"
                  class="form-button form-button-no mr-3"
                  v-bind:class="{ 'border-active': !form.lock }"
                >
                  <label class="form-check-label">
                    Não
                  </label>
                </button>
              </div>
              <div class="form-check form-check-inline">
                <button
                  v-on:click="setButton('lock', 2, $event)"
                  class="form-button mr-3"
                  style="background-color: #888888"
                  v-bind:class="{ 'border-active': form.lock == 2 }"
                >
                  <label class="form-check-label">
                    Sim, porém aberto
                  </label>
                </button>
              </div>
            </div>
          </div>

          <div class="p-field p-col-12">
            <label class="form-check-label">
              Formato:
            </label>
            <div class="d-flex" style="max-width: 600px">
              <div class="form-check form-check-inline">
                <button
                  v-on:click="setButton('format', 0, $event)"
                  class="form-button mr-3"
                  style="background-color: #888888"
                  v-bind:class="{ 'border-active': !form.format }"
                >
                  <font-awesome-icon :icon="['fas', 'square-full']" size="lg" />
                </button>
              </div>
              <div class="form-check form-check-inline">
                <button
                  v-on:click="setButton('format', 1, $event)"
                  class="form-button mr-3"
                  style="background-color: #888888"
                  v-bind:class="{ 'border-active': form.format }"
                >
                  <font-awesome-icon :icon="['fas', 'circle']" size="lg" />
                </button>
              </div>
            </div>
          </div>
          

          <div class="p-field p-col-12">
            <label>Medidas</label>
            <div class="ml-3">
              <div class="d-flex align-items-center mb-3" v-if="!form.format">
                <label style="width: 100px">Altura</label>
                <InputText v-model="form.height" />
              </div>
              <div class="d-flex align-items-center" v-if="!form.format">
                <label style="width: 100px">Largura</label>
                <InputText v-model="form.width" />
              </div>
              <div class="d-flex align-items-center" v-if="form.format">
                <label style="width: 100px">Diâmetro</label>
                <InputText v-model="form.diameter" />
              </div>
            </div>
          </div>

          <div class="p-field p-col-12">
            <label>Foto da B.V.</label>
            <div class="ml-3">
              <input
                type="file"
                class="form-control-file"
                name="picture"
                @change="changePicture"
              />
            </div>
          </div>

          <div class="p-field p-col-12">
            <label>Observação Adicional</label>
            <Textarea v-model="form.additional_observations" rows="5" />
          </div>

          <div class="p-field p-col-12">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="form.assign_work_fronts"
                :value="0"
                id="assign-work-fronts"
              />
              <label class="form-check-label" for="assign-work-fronts">
                Atribuir frentes de trabalho
              </label>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-between">
          <button
            class="btn btn-secondary"
            v-on:click="goBack($event)"
          >
            Voltar
          </button>
          <div v-if="!isEditing">
            <button
              class="btn btn-success"
              v-on:click="save(true, $event)"
            >
              Finalizar e Adicionar B.V.
            </button>
            <button
              class="btn btn-success ml-3"
              v-on:click="save(false, $event)"
            >
              Finalizar Lançamento
            </button>
          </div>
          <div v-else>
            <button
              class="btn btn-success"
              v-on:click="save(false, $event)"
            >
              Salvar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { useRoute } from 'vue-router'

  import InputText from 'primevue/inputtext'
  import Dropdown from 'primevue/dropdown'
  import Textarea from 'primevue/textarea'
  import InputNumber from 'primevue/inputnumber'
  import RadioButton from 'primevue/radiobutton'
  import useSwal from "../../../modules/Swal";
  import Swal from 'sweetalert2/src/sweetalert2.js'

  export default {
    components: {
      InputText,
      Dropdown,
      Textarea,
      InputNumber,
      RadioButton,
    },
    setup() {
      const route = useRoute()
      const { confinedSpaceId } = route.params
      const { showSuccessDialog, showErrorDialog, showAjaxDialog } = useSwal()

      const isEditing = route.params.rad_id ? true : false

      return {
        confinedSpaceId,
        showErrorDialog,
        showSuccessDialog,
        showAjaxDialog,
        isEditing,
        route,
      }
    },
    data() {
      return {
        form: {
          is_flagged: 0,
          without_pictogram: 0,
          is_unreadable: 0,
          without_number: 0,
          is_rescue_point_required: 0,
          has_rescue_point: 0,
          is_rescue_point_flagged: 1,
          is_rescue_point_max_load_indicated: 1,
          rescue_point_has_project: 1,
          lock: 0,
          format: 0,
          height: '',
          width: '',
          diameter: '',
          additional_observations: '',
          picture: '',
          assign_work_fronts: 0
        },
      }
    },
    methods: {
      save(add_another_bv, event) {
        event.preventDefault()

        const app = this

        const url = `/api/confined-spaces/${this.confinedSpaceId}/risk-analysis/`

        const request = {
          url: url + (app.isEditing ? 'update' : 'store'),
          data: new FormData(),
          config: {
            headers: {
              'content-type': 'multipart/form-data',
            },
          },
        }

        for (let k in this.form) {
          request.data.append(k, this.form[k])
        }

        if (app.isEditing) {
          request.data.append('id', app.route.params.confined_space_entry_id)
        }

        Swal.fire({
          title: 'Tem certeza desta operação?',
          text: 'Verifique todos os campos antes de efetuar o cadastro.',
          confirmButtonText: 'Cadastrar',
          cancelButtonText: 'Cancelar',
          showCancelButton: true,
          showLoaderOnConfirm: true,
          preConfirm: function () {
            return app.axios
              .post(request.url, request.data, request.config)
              .then(() => {
                app.showSuccessDialog()
                const nav = add_another_bv ? 0 : -1

                setTimeout(() => {
                  app.$router.go(nav) 
                }, 500)
              })
              .catch(error => {
                let result = ''

                if (error && error.response.data) {
                  let container = document.createElement('div')

                  let paragraph = document.createElement('p')
                  if (error.response.data.message) {
                    paragraph.appendChild(
                      document.createTextNode(error.response.data.message),
                    )
                    paragraph.classList.add('alert')
                    paragraph.classList.add('alert-danger')
                  }

                  let list = document.createElement('ul')
                  for (let key in error.response.data.errors) {
                    let itemElement = document.createElement('li')
                    itemElement.appendChild(
                      document.createTextNode(error.response.data.errors[key]),
                    )
                    list.appendChild(itemElement)
                  }

                  container.appendChild(paragraph)
                  container.appendChild(list)
                  result = container
                }

                app.showErrorDialog(result)
              })
          }
        })
      },

      async getConfinedSpaceEntryData() {
        const app = this

        const rad_id = app.route.params.rad_id

        const data = await app.axios.get(`/api/confined_spaces/getEntry/${rad_id}`)
          .then(({data}) => data.data)
          .catch(error => {
            console.log(error)
            return null
          })

        if (!data) return

        app.form.is_flagged = data.is_flagged ? 1 : 0
        app.form.without_pictogram = data.without_pictogram ? 1 : 0
        app.form.is_unreadable = data.is_unreadable ? 1 : 0
        app.form.without_number = data.without_number ? 1 : 0
        app.form.is_rescue_point_required = data.is_rescue_point_required ? 1 : 0
        app.form.has_rescue_point = data.has_rescue_point ? 1 : 0
        app.form.is_rescue_point_flagged = data.is_rescue_point_flagged ? 1 : 0
        app.form.is_rescue_point_max_load_indicated = data.is_rescue_point_max_load_indicated ? 1 : 0
        app.form.rescue_point_has_project = data.rescue_point_has_project ? 1 : 0
        app.form.lock = data.lock
        app.form.format = data.format
        app.form.height = data.height || ''
        app.form.width = data.width || ''
        app.form.diameter = data.diameter || ''
        app.form.additional_observations = data.additional_observations
        app.form.picture = data.picture
      },

      goBack(event) {
        event.preventDefault()

        setTimeout(() => {
          this.$router.go(-1)
        }, 500)
      },

      changePicture(event) {
        this.form.picture = event.target.files[0]
      },
      
      setButton(button, value, event) {
        if (event) event.preventDefault()
        this.form[button] = value
      },

      toggleButton(value, event) {
        if (event) event.preventDefault()

        if (this.form[value]) this.form[value] = 0
        else this.form[value] = 1
      },
      
      isNotFlaggedClick(event) {
        this.setButton('is_flagged', 0, event)
        this.setButton('without_pictogram', 0, event)
        this.setButton('is_unreadable', 0, event)
        this.setButton('without_number', 0, event)
      },
      noRescuePointRequiredClick(event) {
        this.setButton('is_rescue_point_required', 0, event)
        this.hasNotRescuePointClick(event)
      },
      hasNotRescuePointClick(event) {
        this.setButton('has_rescue_point', 0, event)
        this.setButton('is_rescue_point_flagged', 1, event)
        this.setButton('is_rescue_point_max_load_indicated', 1, event)
        this.setButton('rescue_point_has_project', 1, event)
      },
    },
    watch: {
      noncompliance_model_id: async function (newValue) {
        this.listNoncomplianceModel(newValue)
      },
      noncompliance_model_form_data: function(newValue) {
        console.log(newValue)
        this.form.noncompliance = newValue.description
        this.form.treatise_alternative = newValue.treatise
        this.form.nature_of_risk_alternative = newValue.noncompliance_model_nature_of_risk.name
        this.form.noncompliance_probability = newValue.probability
        this.form.noncompliance_consequences = newValue.consequences
        this.form.cost_center_alternative = newValue.noncompliance_model_cost_center.name
        this.form.degree_of_risk_alternative = newValue.noncompliance_model_degree_of_risk.name

        this.form.standard_item_alternative = newValue.standard_items.reduce(
          (acc, item) => `${acc} ${item.name}`,
          '',
        )
      },
    },
    mounted() {
      if (this.isEditing) this.getConfinedSpaceEntryData()
    }
  }
</script>

<style lang="scss" scoped>
  .buttons {
    padding: 10px 20px;
    font-weight: bold;
    color: white;
    background-color: rgb(145, 145, 145);
    border: black solid 1px;
    border-radius: 4px;
    transition: 0.3s;
  }

  .buttons-active {
    transition: 0.3s;
    background-color: rgb(255, 145, 0);
    border: grey solid 1px;
  }

  .form-button {
    padding: 10px 50px;
    font-weight: bold;
    color: white;
    border: white solid 2px;
    border-radius: 4px;
    transition: 0.3s;
  }

  .form-button-yes {
    background-color: #5de466;
  }

  .form-button-no {
    background-color: #dd364a;
  }

  .border-active {
    transition: 0.3s;
    border: black solid 2px;
  }
</style>
